import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import sidebarLinksData from '../data/sidebarLinks.json';
import { ReactComponent as LogoFPCH } from '../ui/logoFPCH.svg';
import { Link } from 'react-router-dom';
import Icon from '../ui/icons/Icon';
import useAuth from '../hooks/useAuth';
import { LogOut } from 'lucide-react';
import { FOCUS_RING } from './form/styles';
interface sidebarProps {
  pathname: string;
}

interface sidebarLinks {
  name: string;
  subPath: string;
  icon: string;
}

const Sidebar = ({ pathname }: sidebarProps) => {
  const [links, setLinks] = useState<sidebarLinks[]>([]);
  const { t } = useTranslation();
  const { auth, logout } = useAuth();

  useEffect(() => {
    if (auth.isFamily) {
      setLinks(sidebarLinksData.family);
    } else if (auth.isTeacher) {
      setLinks(sidebarLinksData.teacher);
    } else if (pathname.includes('/admin')) {
      setLinks(sidebarLinksData.admin);
    }
  }, [auth.isFamily, auth.isTeacher, pathname]);

  return (
    <div className="min-h-screen w-64 bg-white text-black flex flex-col rounded-r-xl">
      <div className="w-auto p-4">
        <LogoFPCH className="h-7 lg:h-12 w-auto" role="img" aria-label="Formando PerCorsi" />
      </div>
      <nav aria-label={t('shell.mainNav')}>
      <ul className="">
        {links.map((link, index) => {
          const isActive = pathname === link.subPath;
          return (
            <li
              key={index}
              className={`p-2 md:my-8 xl:my-10 ${
                isActive ? 'border-l-4 border-l-fpcred bg-fpcpink text-fpcred' : 'text-gray-500'
              }`}>
              <Link
                to={link.subPath}
                aria-current={isActive ? 'page' : undefined}
                className="flex flex-row items-center ">
                <span aria-hidden="true">
                  <Icon
                    iconName={link.icon}
                    options={{
                      width: 24,
                      height: 24,
                      activeState: isActive,
                    }}
                  />
                </span>
                <span className={'font-semibold ml-2'}>{t('sidebar.' + link.name)}</span>
              </Link>
            </li>
          );
        })}
      </ul>
      </nav>
      {auth.isAuth && (
        <button
          type="button"
          onClick={logout}
          className={`flex items-center justify-center gap-4 self-center rounded-lg px-4 py-2 ${FOCUS_RING}`}>
          <span className="text-fpcred font-bold">{t('loggedMenuLogout')}</span>
          <LogOut className="h-6 w-6 text-fpcred" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default Sidebar;
